import { render, staticRenderFns } from "./_file-loader.vue?vue&type=template&id=c6a631f2&scoped=true"
import script from "./_file-loader.vue?vue&type=script&lang=js"
export * from "./_file-loader.vue?vue&type=script&lang=js"
import style0 from "./_file-loader.vue?vue&type=style&index=0&id=c6a631f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a631f2",
  null
  
)

export default component.exports